import { handleActions } from 'redux-actions';
import {
    setProductCategories,
    setProductCategoriesCount,
    addProductCategorySuccess,
    updateProductCategorySuccess,
    deleteProductCategorySuccess,
} from '../action';

const initialState = {
    raw: [],
    semi: [],
    count: 0,
    loading: false,
    error: null,
    loadedTypes: {},
};

const productCategories = handleActions(
    {
        [setProductCategories]: (state, { payload: { items, type } }) => ({
            ...state,
            [type]: items,
            loadedTypes: {
                ...state.loadedTypes,
                [type]: true,
            },
            error: null,
        }),
        [setProductCategoriesCount]: (state, { payload }) => ({
            ...state,
            count: payload,
        }),
        [addProductCategorySuccess]: (state, { payload }) => ({
            ...state,
            [payload.type]: [...state[payload.type], payload],
            error: null,
        }),
        [updateProductCategorySuccess]: (state, { payload }) => ({
            ...state,
            [payload.type]: state[payload.type].map(category =>
                category.id === payload.id ? payload : category
            ),
            error: null,
        }),
        [deleteProductCategorySuccess]: (state, { payload: { id, type } }) => ({
            ...state,
            [type]: state[type].filter(item => item.id !== id),
            error: null,
        }),
        'SET_CATEGORIES_LOADER': (state, { payload }) => ({
            ...state,
            loading: payload,
        }),
        'SET_CATEGORIES_ERROR': (state, { payload }) => ({
            ...state,
            error: payload,
        }),
    },
    initialState
);

export default productCategories;
